'use client';

import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/features/auth/presentation/providers/auth-provider';
import type { Location } from '@/features/locations/domain/model/location';
import type { LocationsResult } from '@/features/locations/domain/repository/user-locations-repository';
import { locationsListQueryOptions } from '@/features/locations/presentation/queries/locations.queries';

export const useLocations = (initialLocations?: Location[]) => {
  const { user, userInfo } = useAuth();

  return useQuery({
    ...locationsListQueryOptions(user?.id ?? ''),
    enabled: !!user?.id && !!userInfo?.role,
    initialData: initialLocations ? ({ data: initialLocations, error: null } satisfies LocationsResult) : undefined,
  });
};
